import { createFileRoute, redirect } from '@tanstack/react-router'

/** `/settings` n'a pas de contenu propre : on ouvre le profil. */
export const Route = createFileRoute('/_app/settings/')({
  beforeLoad: () => {
    throw redirect({ to: '/settings/profile' })
  },
})
